export const capitalizeFirstLetter = (str: string) =>
  str[0].toUpperCase() + str.slice(1);

export const extractLastPath = (url = '') => {
  // URL에서 쿼리스트링을 제외
  const urlWithoutQuery = url.split('?')[0];
  // 정규식을 사용하여 마지막 path 추출
  const match = urlWithoutQuery.match(/\/([^\\/]+)\/?$/);

  if (match && match[1]) {
    return match[1];
  }
  return '';
};

export const isNumeric = (value: string) =>
  /^-?\d+(\.\d+)?$/.test(value?.toString());

export const getDiscoveryTypeText = (type: string) => {
  if (type?.toUpperCase() === 'BRAND_STORY') {
    return '브랜드스토리';
  }
  if (type?.toUpperCase() === 'W_SERIES') {
    return 'W시리즈';
  }
  if (type?.toUpperCase() === 'LOOKBOOK') {
    return '룩북';
  }
  if (type?.toUpperCase() === 'SHOP_LIVE') {
    return '라이브';
  }
  if (type?.toUpperCase() === 'STYLE_CLIP') {
    return '스타일링';
  }
  if (type?.toUpperCase() === 'EVENT') {
    return '기획전';
  }
  return '';
};

export const getSearchTypeText = (type: string) => {
  if (type === 'recent') {
    return '최근 검색어';
  }
  if (type === 'reco') {
    return '개인화 추천 검색어';
  }
  if (type === 'popular') {
    return '인기 검색어';
  }
  if (type === 'popularBrand') {
    return '많이 찾는 브랜드';
  }
  if (type === 'brand') {
    return '자동완성 검색어_브랜드';
  }
  if (type === 'keyword') {
    return '자동완성 검색어';
  }
  return '';
};

export const getStyleClipRankingTabText = (subTab: string) => {
  if (subTab === 'styling') {
    return '스타일링';
  }
  if (subTab === 'customer') {
    return '회원';
  }
  if (subTab === 'brand') {
    return '브랜드';
  }
  return '';
};
